import React from "react";
import { Target, Telescope } from "lucide-react";
import { MISION, VISION } from "@/data/content";

export default function MisionVision() {
    return (
        <section
            id="mision-vision"
            data-testid="mision-vision-section"
            className="px-5 md:px-10 pb-24 md:pb-32"
        >
            <div className="max-w-[1400px] mx-auto">
                <div className="font-display uppercase tracking-[0.3em] text-orange text-sm md:text-base mb-3 fade-up" style={{ WebkitTextStroke: "1px #326d8e" }}>
                    / Misión · Visión
                </div>
                <h2 className="font-heading text-navy text-4xl md:text-6xl mb-12 fade-up">
                    Nuestra brújula
                </h2>

                <div className="grid md:grid-cols-2 gap-8">
                    <article
                        data-testid="mision-card"
                        className="relative bg-teal text-cream border-[6px] border-navy p-8 md:p-12 hard-shadow-gold fade-up"
                    >
                        <div className="absolute top-0 right-0 stripes-orange w-24 h-24 opacity-40" />
                        <div className="flex items-center gap-3 mb-6">
                            <Target size={28} className="text-gold" />
                            <span className="font-display uppercase tracking-widest text-sm">
                                Misión
                            </span>
                        </div>
                        <h3 className="font-heading text-3xl md:text-4xl mb-6 leading-tight">
                            Empoderar marcas con IA y creatividad disruptiva.
                        </h3>
                        <p className="text-base md:text-lg leading-relaxed font-medium">
                            {MISION}
                        </p>
                    </article>

                    <article
                        data-testid="vision-card"
                        className="relative bg-gold text-navy border-[6px] border-navy p-8 md:p-12 hard-shadow-teal fade-up"
                    >
                        <div className="absolute top-0 right-0 halftone-dots w-24 h-24 opacity-50" />
                        <div className="flex items-center gap-3 mb-6">
                            <Telescope size={28} className="text-navy" />
                            <span className="font-display uppercase tracking-widest text-sm">
                                Visión
                            </span>
                        </div>
                        <h3 className="font-heading text-3xl md:text-4xl mb-6 leading-tight">
                            La agencia más influyente de Guadalajara.
                        </h3>
                        <p className="text-base md:text-lg leading-relaxed font-medium">
                            {VISION}
                        </p>
                    </article>
                </div>
            </div>
        </section>
    );
}
